// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1zCy3","content":"LayoutSettings_content__17TvT"};